import axios from 'axios'
import Vue from 'vue'
import api from '../../../api/apibackend'
import { CHECK_TOKEN_TELEGRAM, SEND_MESSAGE, BROADCAST_MESSAGE, SEND_IMAGE, BROADCAST_IMAGE, BROADCAST_EVERYONE, SEND_PROMO } from './actions.type'
import { FETCH_START, FETCH_END, SENDING_MESSAGE_START, SENDING_MESSAGE_END } from './mutations.type'

const state = {
  loading: false,
  sendingMessage: false
}

const getters = {
  checkLoading: state => state.loading,
  sendingMessage: state => state.sendingMessage
}

const mutations = {
  [FETCH_START](state) {
    state.loading = true
  },
  [FETCH_END](state) {
    state.loading = false
  },
  [SENDING_MESSAGE_START](state) {
    state.sendingMessage = true
  },
  [SENDING_MESSAGE_END](state) {
    state.sendingMessage = false
  }
}

const actions = {
  async [CHECK_TOKEN_TELEGRAM]({ commit }, { telegramBotToken }) {
    try {
      commit(FETCH_START)
      const res = await axios.get(`https://api.telegram.org/bot${telegramBotToken}/getWebhookInfo`)
      commit(FETCH_END)
      return Promise.resolve({ status: true, message: 'Token is connected' })
    } catch (err) {
      commit(FETCH_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: 'Token is not connected'
      })
    }
  },
  async [SEND_MESSAGE] ({ commit }, {clientId, text, storeId}) {
    try {
      commit(SENDING_MESSAGE_START)
      if(storeId) {
        await api.post(`/store/send_notification/${clientId}/${storeId}`, {
          message: text
        })
      } else {
        await api.post(`sendMessage/${clientId}`, { text })
      }
      commit(SENDING_MESSAGE_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Mensaje enviado exitosamente'
      })
    } catch (err) {
      commit(SENDING_MESSAGE_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al enviar el mensaje'
      })
    }
  },
  async [BROADCAST_MESSAGE] ({ commit }, {text, storeId}) {
    try {
      commit(SENDING_MESSAGE_START)
      if(storeId){
        await api.post('/store/store_broadcast/' + storeId, {message: text})        
      } else {
        await api.post('sendMessage', text)
      }

      commit(SENDING_MESSAGE_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Mensaje enviado exitosamente'
      })
      
    } catch (err) {
      commit(SENDING_MESSAGE_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al enviar el mensaje'
      })
    }
  },
  async [BROADCAST_EVERYONE] ({ commit }, text) {
    try {
      commit(SENDING_MESSAGE_START)
      const { data } = await api.post('sendMessage/bots', text)
      commit(SENDING_MESSAGE_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Mensaje enviado exitosamente'
      })
      return data
    } catch (err) {
      commit(SENDING_MESSAGE_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al enviar el mensaje'
      })
    }
  },
  async [SEND_IMAGE] ({ commit }, {clientId, text, image, storeId}) {
    try {
      commit(SENDING_MESSAGE_START)
      const formData = new FormData()
      formData.append('text', text)
      formData.append('image', image, image.name)

      if(storeId) {
        formData.append('message', text)
        await api.post(`/store/send_notification/${clientId}/${storeId}`, formData)
      } else {
        await api.post(`sendImage/${clientId}`, formData)
      }

      commit(SENDING_MESSAGE_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Imagen enviada exitosamente'
      })
    } catch (err) {
      commit(SENDING_MESSAGE_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al enviar la imagen'
      })
    }
  },
  async [BROADCAST_IMAGE] ({ commit }, {text, image, storeId}) {
    try {
      commit(SENDING_MESSAGE_START)
      const formData = new FormData()
      formData.append('text', text)
      formData.append('image', image, image.name)

      if(storeId){
        formData.append('message', text)
        await api.post('/store/store_broadcast/' + storeId, formData)        
      } else {
        await api.post('sendMessage', text)
      }

      commit(SENDING_MESSAGE_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Imagen enviada exitosamente'
      })
    } catch (err) {
      commit(SENDING_MESSAGE_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al enviar la imagen'
      })
    }
  },
  async [SEND_PROMO] ({ commit }, {productId, text, web, storeId}) {
    try {
      commit(SENDING_MESSAGE_START)
      if(web) {
        await api.post(`store/product_broadcast/${storeId}/${productId}`, { text })
      } else {
        await api.post(`products/${productId}/sendpromo`, { text })
      }
      commit(SENDING_MESSAGE_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'success',
        text: '✔️ Promoción enviada exitosamente'
      })
    } catch (err) {
      commit(SENDING_MESSAGE_END)
      Vue.notify({
        group: 'loggedIn',
        type: 'error',
        text: '❌ Ha ocurrido un error al enviar la promoción'
      })
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
